import { fork, join } from 'redux-saga/effects'
import { watchEmits, watchRemote, watchRequests } from 'redux-saga-sc'
import flashesSaga from 'client/features/flashes/sagas'
import sessionSaga from 'client/features/session/sagas'
import clientSaga from 'client/features/client/sagas'
import reportsSaga from 'client/features/reports/sagas'
import usersSaga from 'client/features/users/sagas'
import socket from 'client/core/socket'

export const root = function* () {
    const sagas = [
        ...sessionSaga,
        ...clientSaga,
        ...flashesSaga,
        ...reportsSaga,
        ...usersSaga
    ]
    if (__CLIENT) {
        sagas.push(watchRemote(socket))
        sagas.push(watchRequests(socket))
        sagas.push(watchEmits(socket))
    } 
    yield sagas
}

export const waitAll = (sagas, req) => function* genTasks() {
    const tasks = yield sagas.map(([saga]) => fork(saga, req))
    yield tasks.map(join)
}


// WEBPACK FOOTER //
// ./src/client/core/sagas.js